import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';

const PublicRoute = () => {
  const { token } = useSelector((state) => state.auth);

  return token ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet />;
};

export default PublicRoute;
